module.exports = __webpack_public_path__ + "99506642.svg";